require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./iwdvideoseries.json") })
        }
      }, "path---iwdvideoseries");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---iwdvideoseries!./.cache/json/iwdvideoseries.json
// module id = 1146
// module chunks = 231608221292675